import { defineStore } from "pinia";
import { ref } from "vue";

export const useSessionExpiredStore = defineStore("sessionExpired", () => {
  const isSessionExpired = ref(false);

  function setSessionExpired(value: boolean) {
    isSessionExpired.value = value;
  }

  return {
    isSessionExpired,
    setSessionExpired,
  };
});
